import React from 'react'
import { observer } from 'mobx-react'

import Typography from '../../UniformComponents/Typography'
import { unescapeHtmlTags } from '../../utils/helpers'

const DraggableQuestion = ({ question, activeSlide, getTitle, surveyId }) => (
    <div className={`dndQuestion possible ${activeSlide?.questionIdsForSurvey(surveyId).includes(question.id) ? 'present_in_slide' : ''}`}>
        <div
            className="draggableQuestion"
            style={{
                alignItems: 'center',
                justifyContent: 'space-Between',
                width: '100%',
                gap: 10,
                display: 'flex',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 5, width: '90%' }}>
                <div className={`questionColorCode code_${question.metadata?.oid}`} />

                <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                    <i className="fa-solid fa-grip-dots-vertical" />

                    <Typography type="b" style={{ overflow: 'hidden', textOverflow: 'ellipsis', textWrap: 'nowrap' }}>{unescapeHtmlTags(question.kpiName || getTitle(question))}</Typography>
                </div>
            </div>

            {!activeSlide?.questionIdsForSurvey(surveyId).includes(question.id) && <i className="far fa-plus" style={{ color: '#715AF8', position: 'absolute', right: 10 }} />}
        </div>
    </div>
)

export default observer(DraggableQuestion)
